import { StaticImage } from "gatsby-plugin-image";
import React from "react";
import styled from "../../lib/styled";

interface FeaturedProductProps {
    productUrl: string;
    bannerImage: string;
    name: string;
    image: string;
    description: JSX.Element | JSX.Element[];
    price: string;
    infoFooter: string;
    underPrice: string;
}
export const FeaturedProduct: React.FC<FeaturedProductProps> = (props) => {
    return (
        <>

            <Wrapper>
                <CoverImage image={props.bannerImage} />
            </Wrapper>

            <ImageInfoWrapper>

                <ProductWrapper target="_blank" rel="nofollow noreferrer" href={props.productUrl}>
                    <ProductImage src={props.image} />
                </ProductWrapper>

                <InfoWrapper>
                    <h3>{props.name}</h3>
                    <p>{props.description}</p>
                    <p className="price">{props.price}</p>
                    <p>{props.underPrice}</p>
                    <small><i>{props.infoFooter}</i></small>
                </InfoWrapper>
            </ImageInfoWrapper>
            <PreOrderImage>
                <a target="_blank" rel="nofollow noreferrer" href={props.productUrl}>
                    <StaticImage
                        alt="Preorder now"
                        layout="constrained"
                        width={250}
                        src="../../images/storeorderbutton.png"
                        style={{ marginBottom: "1rem" }}
                    />
                </a>
            </PreOrderImage>
        </>
    );
};

const PreOrderImage = styled.div`
    margin: 20px 0;
    display: flex;
    justify-content: center;
    align-items: center;

`
const Wrapper = styled.div`
  overflow: hidden;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 830px;
  height: 200px;
  background-color: ${({ theme }) => theme.color.darkThree};
  margin-bottom: 15px;
`;


const CoverImage = styled.div<{ image: string }>`
  width: 100%;
  height: 100%;
  background-image: ${({ image }) => `url(${image})`};
  background-size: cover;
  background-position: center right;
  background-repeat: no-repeat;
  position: absolute;
`;

const ProductWrapper = styled.a`
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  width: 49%;
  @media (max-width: 600px){
        width: 100%;
    }
`;


const ImageInfoWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 25px;
  @media (max-width: 600px){
      flex-direction: column;
  }
`;

const InfoWrapper = styled.div`
    background-color: #d4d4d4;
    padding: 20px;
    width: 49%;
    @media (max-width: 600px){
        width: 100%;
    }
    margin-bottom: 15px;

    .price {
        padding-top: 30px;
        font-size: 20px;
        font-weight: bold;
    }
    i {
        font-style: italic;
    }
`;


const ProductImage = styled.img`
  width: 100%;
  height: auto;
  margin-bottom: 10px;
`;